<template>
  <div class="content-scoll">
    <div class="teacher-area">
      <div class="teacher">
        <div class="scroll">
          <card>
            <list
              v-if="init"
              :columns="columns"
              :modalCreate="modalCreate"
              :removeLink="removeLink"
              :cardLink="cardLink"
              :params="params"
              :isUpdate="true"
              :isAdd="true"
              :itemLink="itemLink"
              :setLink="setLink"
              :fields="fields"
              :searchDisable="true"
              @change="change"
              @changeFunction="changeFunction"
              v-model="val"
            />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    group_id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `business/teacher_groups/${this.group_id}/notifications`;
    this.setLink = `business/teacher_groups/${this.group_id}/notifications`;
  },
  watch: {
    group_id(val) {
      this.init = false;
      this.params["page"] = 1;
      this.itemLink = `business/teacher_groups/${val}/notifications`;
      this.setLink = `business/teacher_groups/${val}/notifications`;
      setTimeout(() => {
        this.init = true;
      }, 10);
    },
  },
  name: "notifications",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      init: true,
      params: {},
      val: [],
      /**START ADD ITEM */ 
      modalCreate: "notification",
      fields: [
        {
					key: "notifications",
					label: "Кому отправить объявление:",
					type: "notifications",
					textType: "text",
					items: [
						'Всем',
						'Родителям',
						'Ученикам',
					]
				},
        {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          key: "description",
          label: "Текст",
          type: "textarea",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_notification",
      itemLink: "",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          full: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
.scroll {
  position: absolute;
  overflow: scroll;
  width: 100%;
  height: 100%;
}
</style>
